import { combineReducers } from 'redux';

import { booksReducer } from './booksStore/reducers';
import { RootState } from '../reducers/types';

export const rootReducer = combineReducers<RootState>({
  books: booksReducer,
});
